/**
 * Sticky Modal Button Handler
 * Handles the sticky button functionality for Novuna modal
 */

class StickyModalButton {
    constructor() {
        this.isProcessing = false;
        this.init();
    }

    init() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.bindEvents());
        } else {
            this.bindEvents();
        }
    }

    bindEvents() {
        // Handle sticky button click
        $(document).on('click', '.sticky-modal-button .sticky-btn', (e) => {
            this.handleStickyButtonClick(e);
        });
    }

    handleStickyButtonClick(e) {
        e.preventDefault();
        
        const $button = $(e.currentTarget);
        const $form = $('.product-form form');
        
        
        // Prevent multiple simultaneous requests
        if (this.isProcessing) {
            return;
        }
        
        // Check if button is already disabled
        if ($button.prop('disabled')) {
            return;
        }
        
        if ($form.length === 0) {
            return;
        }
        
        // Set processing flag
        this.isProcessing = true;
        
        // Disable button and show loading state
        $button.prop('disabled', true).addClass('loading');
        $button.html('<i class="fas fa-spinner fa-spin"></i> Adding...');
        
        // Get current variant ID
        const variantId = $form.find('input[name="id"]').val();
        const quantity = $form.find('input[name="quantity"]').val() || 1;
        
        //console.log('Adding to cart - Variant ID:', variantId, 'Quantity:', quantity);
        
        // Prepare form data for cart add
        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', quantity);
        formData.set('sections', 'cart-drawer,variant-added');
        formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);
        
        // Capture adjustment properties if they exist
        this.captureAdjustmentProperties($form, formData);
        
        // Add to cart using Shopify's native method
        fetch(`${Shopify.routes.root}cart/add.js`, {
            body: formData,
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            return response.json().then(responseJson => {
                return { response: response, data: responseJson };
            });
        })
        .then(({ response, data: responseJson }) => {
            //console.log('Cart add response:', response.status, responseJson);
            
            // Check for success using theme's approach
            if (response.ok && !responseJson.status) {
                // Success - close popup and open cart drawer
                this.closeModal();
                this.updateCart(responseJson);
            } else {
                // Error handling with specific messages
                this.handleError(response, responseJson);
            }
        })
        .catch(error => {
            this.showError('Failed to add item to cart. Please try again.');
        })
        .finally(() => {
            // Reset button state and processing flag
            this.isProcessing = false;
            this.resetButton($button);
        });
    }

    closeModal() {
        $('#Nou_popupiframe').slideUp('fast');
        $('#Nou_popupiframe').removeClass('active');
        $('body').removeClass('modal-open');
        $('.sticky-modal-button').removeClass('show');
    }

    updateCart(responseJson) {
        // Trigger cart update events
        fetch(`${Shopify.routes.root}cart.js`)
            .then(response => response.json())
            .then(cartContent => {
                cartContent.sections = responseJson.sections;
                
                // Dispatch cart change events
                document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                    bubbles: true,
                    detail: {
                        items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
                        cart: cartContent
                    }
                }));
                
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                    bubbles: true,
                    detail: {
                        baseEvent: 'variant:add',
                        cart: cartContent
                    }
                }));
                
                // Try to open cart drawer, fallback to cart page
                this.openCartDrawer();
            });
    }

    openCartDrawer() {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && window.themeVariables.settings.cartType === 'drawer') {
            cartDrawer.show();
        } else {
            // Fallback to cart page
            window.location.href = '/cart';
        }
    }

    handleError(response, responseJson) {
        
        let errorMessage = 'Failed to add item to cart. Please try again.';
        
        // Use theme's error handling approach
        if (responseJson.status) {
            // Shopify returns error with status field
            if (responseJson.description) {
                errorMessage = responseJson.description;
            } else if (responseJson.message) {
                errorMessage = responseJson.message;
            }
        } else if (response.status === 422) {
            // Check for specific error messages
            if (responseJson.message && responseJson.message.toLowerCase().includes('maximum quantity')) {
                errorMessage = 'This item has reached the maximum quantity in your cart. Please check your cart or reduce the quantity.';
            } else if (responseJson.message && responseJson.message.toLowerCase().includes('already in your cart')) {
                errorMessage = 'This item is already in your cart. Please check your cart or adjust the quantity.';
            } else if (responseJson.description) {
                errorMessage = responseJson.description;
            } else if (responseJson.message) {
                errorMessage = responseJson.message;
            }
        } else if (response.status === 400) {
            errorMessage = 'Invalid request. Please refresh the page and try again.';
        } else if (response.status === 404) {
            errorMessage = 'Product not found. Please refresh the page and try again.';
        }
        
        this.showError(errorMessage);
    }

    showError(message) {
        alert(message);
    }

    captureAdjustmentProperties($form, formData) {
        // Look for adjustment properties in the form
        const adjustmentInputs = $form.find('input[name^="properties["]');
        
        adjustmentInputs.each((index, input) => {
            const $input = $(input);
            const name = $input.attr('name');
            const value = $input.val();
            
            if (value && value.trim() !== '') {
                formData.set(name, value);
            }
        });
        
        // Also look for inputs that are associated with this form via the 'form' attribute
        const formId = $form.attr('id');
        if (formId) {
            const associatedInputs = $(`input[form="${formId}"][name^="properties["]`);
            
            associatedInputs.each((index, input) => {
                const $input = $(input);
                const name = $input.attr('name');
                const value = $input.val();
                
                if (value && value.trim() !== '') {
                    formData.set(name, value);
                }
            });
        }
    }

    resetButton($button) {
        $button.prop('disabled', false).removeClass('loading');
        $button.html('<svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 6.5H18.5V6C18.5 4.54131 17.9205 3.14236 16.8891 2.11091C15.8576 1.07946 14.4587 0.5 13 0.5C11.5413 0.5 10.1424 1.07946 9.11091 2.11091C8.07946 3.14236 7.5 4.54131 7.5 6V6.5H2C1.60218 6.5 1.22064 6.65804 0.93934 6.93934C0.658035 7.22064 0.5 7.60218 0.5 8V23C0.5 23.3978 0.658035 23.7794 0.93934 24.0607C1.22064 24.342 1.60218 24.5 2 24.5H24C24.3978 24.5 24.7794 24.342 25.0607 24.0607C25.342 23.7794 25.5 23.3978 25.5 23V8C25.5 7.60218 25.342 7.22064 25.0607 6.93934C24.7794 6.65804 24.3978 6.5 24 6.5ZM8.5 6C8.5 4.80653 8.97411 3.66193 9.81802 2.81802C10.6619 1.97411 11.8065 1.5 13 1.5C14.1935 1.5 15.3381 1.97411 16.182 2.81802C17.0259 3.66193 17.5 4.80653 17.5 6V6.5H8.5V6ZM24.5 23C24.5 23.1326 24.4473 23.2598 24.3536 23.3536C24.2598 23.4473 24.1326 23.5 24 23.5H2C1.86739 23.5 1.74021 23.4473 1.64645 23.3536C1.55268 23.2598 1.5 23.1326 1.5 23V8C1.5 7.86739 1.55268 7.74021 1.64645 7.64645C1.74021 7.55268 1.86739 7.5 2 7.5H7.5V10C7.5 10.1326 7.55268 10.2598 7.64645 10.3536C7.74021 10.4473 7.86739 10.5 8 10.5C8.13261 10.5 8.25979 10.4473 8.35355 10.3536C8.44732 10.2598 8.5 10.1326 8.5 10V7.5H17.5V10C17.5 10.1326 17.5527 10.2598 17.6464 10.3536C17.7402 10.4473 17.8674 10.5 18 10.5C18.1326 10.5 18.2598 10.4473 18.3536 10.3536C18.4473 10.2598 18.5 10.1326 18.5 10V7.5H24C24.1326 7.5 24.2598 7.55268 24.3536 7.64645C24.4473 7.74021 24.5 7.86739 24.5 8V23Z" fill="#66435A"></path></svg> Add To Bag');
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new StickyModalButton();
});

// Also initialize if DOM is already loaded
if (document.readyState !== 'loading') {
    new StickyModalButton();
}
